export const CUSTOM_MAT_COLOR_FORMATS = {
    display: {
        colorInput: 'hex',
    },
};
